@if (options().length || !autoSelectFirst()) {
  <div class="select-field" [class.is-open]="open()">
    @if (title().length) {
      <div class="title">
        {{ title() }}
        @if (required()) {
          <span aria-hidden="true">*</span>
        }
        @if (toolTipMsg().length) {
          <fa-icon
            class="info"
            [icon]="faInfoCircle"
            [andorTooltip]="toolTipMsg()"
            tooltipPosition="right"></fa-icon>
        }
      </div>
    }
    <div
      #selectTrigger
      class="selected {{ open() ? 'is-open' : '' }} {{ disabled() ? 'is-disabled' : '' }}"
      role="combobox"
      aria-haspopup="listbox"
      [attr.tabindex]="disabled() ? null : 0"
      [attr.aria-expanded]="open()"
      [attr.aria-required]="required() || null"
      [attr.aria-disabled]="disabled()"
      [attr.aria-label]="title() || null"
      (click)="toggleOpen()"
      (keydown)="onTriggerKeydown($event)"
      [andorTooltip]="disabled() && toolTipMsg().length ? toolTipMsg() : ''">
      <span class="leading-icon" aria-hidden="true"><ng-content select="[select-leading]" /></span>
      @if (displayedOption(); as option) {
        <div class="name">
          {{ option.name | translate }}
        </div>
        @if (option.tag) {
          <div class="tag">{{ option.tag }}</div>
        }
      } @else {
        <div class="name placeholder">{{ placeholder() }}</div>
      }
      <div class="open">
        @if (infoTooltip().length) {
          <fa-icon
            class="info-badge"
            [icon]="faInfoCircle"
            [andorTooltip]="infoTooltip()"
            (click)="$event.stopPropagation()"></fa-icon>
        } @else if (!disabled()) {
          <fa-icon class="{{ open() ? 'is-open' : '' }}" [icon]="faChevronDown"></fa-icon>
        }
      </div>
    </div>

    <andor-context-menu
      mode="styled"
      [matchTriggerWidth]="true"
      [yPosition]="menuYPosition()"
      (opened)="onOpened()"
      (closed)="onClosed()">
      <div
        class="options"
        role="listbox"
        #optionsContainer
        [style.max-height.px]="optionsMaxHeightPx()">
        @for (option of options(); track option.id; let i = $index) {
          <div
            (click)="selectOption(option)"
            (keydown)="onOptionKeydown($event, option, i)"
            class="option"
            role="option"
            tabindex="-1"
            [attr.aria-selected]="option.id === selectedOption()?.id"
            [class.is-active]="option.id === selectedOption()?.id"
            #optionRow>
            @if (optionIconTemplate(); as iconTemplate) {
              <span class="option-icon" aria-hidden="true">
                <ng-container
                  [ngTemplateOutlet]="iconTemplate"
                  [ngTemplateOutletContext]="{ $implicit: option }" />
              </span>
            }
            <div class="name" #optionName>
              <span class="ticker-text">{{ option.name | translate }}</span>
            </div>
            <div class="actions">
              @if (option.id === selectedOption()?.id) {
                <div class="active">
                  <fa-icon [icon]="faCheck"></fa-icon>
                </div>
              }
              @if (option.tag) {
                <div class="tag">{{ option.tag }}</div>
              }
            </div>
          </div>
        }
      </div>
    </andor-context-menu>
  </div>
}
